export default "__VITE_ASSET__46tgAw20__"